export interface Chat {
  chat: string;
  chatId: string;
  createdAt: string;
}

export const CHATS_STORAGE_KEY = 'ama-local-storage-chats';
export const CHAT_ID_PREFIX = 'ama-local-storage-key-';
